module.exports = __webpack_public_path__ + "static/Tanishq-e72737a066eb25a8406415e19c93325f.jpeg";